import { useState } from "react";
import { TInputProps } from "./Input.type";
import { handleValidation } from "../../../utils/validationInput";
// https://react-icons-kit.vercel.app/guide DOCS
import { Icon } from "../Icon";
import { eye, eyeBlocked } from "react-icons-kit/icomoon";
// https://react-icons-kit.vercel.app/guide DOCS
import "./InputCss.css";

const INPUT_COLOR = "#D0D0D0";
const INPUT_COLOR_ERROR = "red";


export default function Input({
  type,
  label,
  fieldName,
  register,
  required,
  error,
  onChange,
  onBlur,
  style,
  placeholder,
  readOnly,
  value,
  pattern,
  ...props
}: TInputProps) {
  // This states handle status icon-eye on input type password
  const [showPassword, handleShowPassword] = useState(false);
  const inputPattern = label === "DNI" ? "^[a-zA-Z0-9]*$" : undefined;

  return (
    <div className="box">
      {/* INPUT */}
      <input
        pattern={pattern ? pattern : inputPattern}
        readOnly={readOnly}
        className="input"
        placeholder={placeholder}
        type={showPassword && type === "password" ? "text" : type}
        {...register(fieldName, {
          required,
          validate: (value: any) => handleValidation(type, value),
          onChange: (e) => {
            onChange && onChange(e);
          },
          onBlur: (e) => {
            onBlur && onBlur(e);
          },
        })}
        name={fieldName}
        value={value}
        title={label === "DNI" ? "Ingrese solo números" : undefined}
        style={{
          cursor: "pointer",
          borderColor: `${error ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
          ...style,
        }}
        {...props}
      />
      {/* LABEL */}
      {label && <span className="label">{label}</span>}

      {/* BUTTON EYE */}
      {type === "password" && (
        <Icon
          icon={showPassword ? eye : eyeBlocked}
          className="eyebtn"
          onClick={() => handleShowPassword(!showPassword)}
          style={{ color: INPUT_COLOR }}
        />
      )}

      {/* ERRORS MESSAGE */}
      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{label} es requerido*</span>
      )}
    </div>
  );
}
